import { render } from "./CreateSinister.vue?vue&type=template&id=a1cee6ea"
import script from "./CreateSinister.vue?vue&type=script&lang=js"
export * from "./CreateSinister.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__